export const INFINITE_SCROLL = { loader: 'blocked' };
export const PRINCIPALS_RESOURCE = 'supportPrincipals';

export const IMPERSONATION_REQUEST_RESOURCE = 'createImpersonationRequest';
export const IMPERSONATION_DURATIONS_RESOURCE = 'impersonationAllowedDurations';
export const IMPERSONATION_FORM_NAME = 'impersonationRequest';

